import React from 'react';
import Appearance from 'styles/Appearance.js';
import ProgressBar from 'views/ProgressBar.js';

const PageControl = ({ data, limit, loading, offset, onClick, style }) => {

    const onPageClick = direction => {

        let nextOffset = 0;
        switch(direction) {
             case 'next':
             nextOffset = offset + limit;
             break;

             case 'back':
             nextOffset = offset - limit;
             break;

             default:
             if(!isNaN(direction)) {
                 nextOffset = (direction - 1) * limit;
             }
        }
        if(typeof(onClick) === 'function') {
            onClick(nextOffset < 0 ? 0 : nextOffset);
        }
    }

    const getContent = () => {

        if(!data) {
            return null;
        }

        let { current_page, number_of_pages } = data;
        if(number_of_pages <= 1) {
            return null;
        }
        return (
            <div style={{
                padding: 10,
                position: 'relative',
                ...style
            }}>
                {loading === true && (
                    <div style={{
                        borderRadius: 2,
                        left: 0,
                        overflow: 'hidden',
                        position: 'absolute',
                        height: 2,
                        right: 0,
                        top: 0,
                        width: '100%'
                    }}>
                        <ProgressBar/>
                    </div>
                )}
                <div style={{
                    alignItems: 'center',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    margin: 'auto'
                }}>
                    <div 
                    className={current_page !== 1 ? 'cursor-pointer' : ''}
                    onClick={current_page !== 1 ? onPageClick.bind(this, 'back') : null}
                    title={'Previous Page'}
                    style={{
                        alignItems: 'center',
                        display: 'flex',
                        flexDirection: 'row',
                        marginRight: 12,
                        opacity: current_page === 1 ? 0.25 : 1
                    }}>
                        <img
                        src={'images/back-arrow-light-grey-small.png'}
                        style={{
                            height: 12,
                            objectFit: 'contain',
                            width: 12,
                        }}/>
                        <span style={{
                            ...Appearance.textStyles.defaultText(),
                            lineHeight: 1,
                            marginLeft: 4
                        }}>{'Previous'}</span>
                    </div>
                    {[...Array(number_of_pages < 5 ? number_of_pages : 5)].map((entry, index) => {

                        // only show 5 pages at a time, centered around current page
                        let pageNumber = 0;
                        if(number_of_pages <= 5) {
                            pageNumber = index + 1;
                        } else {
                            if(current_page <= 3) {
                                pageNumber = index + 1;
                            } else if(current_page >= number_of_pages - 2) {
                                pageNumber = number_of_pages - 4 + index;
                            } else {
                                pageNumber = current_page - 2 + index;
                            }
                        }
                        
                        // determine if this page is selected
                        const selected = pageNumber === current_page;

                        return (
                            <div
                            key={pageNumber}
                            className={'paging-number'}
                            onClick={onPageClick.bind(this, pageNumber)}
                            style={{
                                marginLeft: index === 0 ? 0 : 2,
                                marginRight: index === 2 ? 0 : 2
                            }}>
                                <div style={{
                                    alignItems: 'center',
                                    border: selected && `2px solid ${Appearance.colors.divider()}`,
                                    borderRadius: 8,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    height: 35,
                                    justifyContent: 'center',
                                    flex: 'none',
                                    minWidth: 35,
                                    textAlign: 'center',
                                    width: '100%'
                                }}>
                                    <span
                                    key={pageNumber}
                                    style={{
                                        ...Appearance.textStyles.defaultText(),
                                        width: '100%',
                                    }}>{pageNumber}</span>
                                </div>
                            </div>
                        )
                    })}
                    <div 
                    className={current_page !== number_of_pages ? 'cursor-pointer' : ''}
                    onClick={current_page !== number_of_pages ? onPageClick.bind(this, 'next') : null}
                    title={'Next Page'}
                    style={{
                        alignItems: 'center',
                        display: 'flex',
                        flexDirection: 'row',
                        marginLeft: 12,
                        opacity: current_page !== number_of_pages ? 1 : 0.25
                    }}>
                        <span style={{
                            ...Appearance.textStyles.defaultText(),
                            lineHeight: 1,
                            marginRight: 4
                        }}>{'Next'}</span>
                        <img
                        src={'images/next-arrow-light-grey-small.png'}
                        style={{
                            height: 12,
                            objectFit: 'contain',
                            width: 12
                        }}/>
                    </div>
                </div>
            </div>
        )
    }

    return getContent();
}

export default PageControl;
